import React from "react";
import Link from "../utils/link";
import {GatsbyImage, getImage} from "gatsby-plugin-image";
import Fade from "react-reveal/Fade";

const Partners = ({partners}) => {
  return (
    <section className='partners'>
     <Fade bottom distance='40px'>
       <div className='partners__inner'>
         <div className='partners__items'>
           {
             partners?.length > 0 && partners.map((el, i) => (
               <Link to={el.link} key={i} className='partners__item'>
                 <GatsbyImage loading='lazy' image={getImage(el.logo?.localFile)} alt={el.altText}/>
               </Link>
             ))
           }
         </div>
       </div>
     </Fade>
    </section>
  )
}

export default Partners